export default __webpack_public_path__ + "static/media/invoice.692b49dd.png";